<template>
  <div class="yajinbujiao">
    <SelectInpatient @selectChange="selectChange" />
    <noData v-show="!info.zyBed && !loading" title="暂无数据" />
    <van-loading v-show="loading" class="my-loading" type="spinner" color="#1989fa" />
    <div v-show="!loading && info.zyBed">
      <van-cell-group class="list-box" inset>
        <van-cell title="就诊人" :value="info.patientName" />
        <van-cell title="医院名称" :value="info.patientName? '苏州市广济医院' : ''" />
        <van-cell title="住院科室" :value="info.deptName" />
        <van-cell title="床位号" :value="info.zyBed" />
      </van-cell-group>
      <van-cell-group class="money-box" inset>
        <van-cell title="押金余额" :value="info.balance ? `￥${info.balance}` : ''" />
      </van-cell-group>
      <div class="money-list">
        <h4 class="money-title">选择预缴金额</h4>
        <van-row gutter="10">
          <van-col v-for="item in moneyList" :key="item" span="8" @click="moneyChange(item)">
            <div class="money-list-item" :class="{'money-list-active': moneyActive === item && !money}">￥{{ item }}.00</div>
          </van-col>
          <van-col span="16">
            <div class="money-list-input">
              <van-cell-group>
                <van-field v-model="money" type="digit" clearable placeholder="请输入整百金额" />
              </van-cell-group>
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="money-bottom-btn">
        <van-button :loading="payLoading" class="btn" type="info" block :disabled="!info.zyBed" @click="payment">立即缴费</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import SelectInpatient from '@/components/selectInpatient'
import inpatientMinxins from './mixins'
export default {
  name: 'Yajinbujiao',
  components: {
    SelectInpatient
  },
  mixins: [inpatientMinxins],
  data() {
    return {
      moneyList: [
        500, 1000, 1500, 2000
      ],
      money: '',
      moneyActive: 500,
      admissionNum: '',
      patientZyName: '',
      info: {
      },
      payLoading: false,
      loading: false,
      id: ''
    }
  },
  created() {
    const userInfo = localStorage.getItem('userInfo')
    const id = JSON.parse(userInfo)?.id
    this.id = id || ''
  },
  mounted() {
  },
  methods: {
    getData() {
      if (!this.admissionNum) return
      const obj = {
        admissionNum: this.admissionNum,
        patientZyName: this.patientZyName
      }
      this.loading = true
      this.$Apis.getPatientZyInfo(obj).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.info = res.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    moneyChange(item) {
      this.moneyActive = item
      this.money = ''
    },
    payment() {
      if (this.money) {
        if (this.money % 100 === 0) {
          this.pay(this.money)
        } else {
          this.$toast('请输入整百金额')
        }
      } else {
        this.pay(this.moneyActive)
      }
    },
    pay(num) {
      this.$dialog.alert({
        title: '标题',
        message: `确定重置${num}元？`,
        showCancelButton: true
      }).then(() => {
        const params = {
          amt: parseFloat((num + '.00')),
          patientSfzh: this.patientZySfzh,
          zyNo: this.admissionNum,
          currentUserId: this.id
        }
        this.payLoading = true
        this.$Apis.zyPay(params).then(res => {
          this.payLoading = false
          if (res.code === 200) {
            location.href = res.data
          } else {
            this.$toast(res.message)
          }
        }).catch(err => {
          this.payLoading = false
          this.$toast(err.message)
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
@moneyHeight: .4rem;
.yajinbujiao{
  margin: .15rem 0;
  .list-box{
    margin-top: .1rem;
    padding: .1rem 0;
  }
  .money-box{
    margin-top: .1rem;
    /deep/.van-cell{
      border-radius: .1rem;
    }
    /deep/.van-cell__value{
      color: #2e86f8;
    }
  }
  .money-title{
    font-size: .16rem;
    line-height: .48rem;
  }
  .money-list{
    background-color: #fff;
    margin: .1rem .15rem .1rem;
    padding: 0 .1rem .1rem;
    line-height: .3rem;
    &-item{
      width: 1.1rem;
      // margin: 0 .01rem;
      margin-bottom: .1rem;
      text-align: center;
      border: 1px solid #F6F9FE;
      background:#F6F9FE;
      color: #2B8CFF;
      height: @moneyHeight;
      line-height: @moneyHeight;
      font-size: .16rem;
      border-radius: .04rem;
    }
    &-active{
      border: 1px solid #2e86f8;
      background-color: #2e86f8;
      color: #fff;
    }
    &-input{
      height: @moneyHeight;
      line-height: @moneyHeight;
      border-radius: .08rem;
      /deep/.van-hairline--top-bottom::after{
          border-color: #fff;
        }
      /deep/.van-cell{
        background: #F6F9FE;
        border-radius: .08rem;
        .van-field__control::placeholder{
          color: #2e86f8;
        }
      }
    }
  }
  .money-bottom-btn{
    margin: 0 .1rem;
    .btn{
      border-radius: .4rem;
    }
  }
}
</style>
